import { render } from "./WebWorker.vue?vue&type=template&id=59f1c176"
import script from "./WebWorker.vue?vue&type=script&lang=js"
export * from "./WebWorker.vue?vue&type=script&lang=js"

import "./WebWorker.vue?vue&type=style&index=0&id=59f1c176&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__